/**
 * The MapGeoid globe mark — the small illustrated world that stands in for
 * the "o" in "Geoid" wherever the MapGeoid wordmark appears (the portal
 * footer, the login page). Pulled out as its own component so neither place
 * carries its own copy of the SVG path data.
 */
export default function MapGeoidGlobe({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
      aria-hidden="true"
    >
      <defs>
        <clipPath id="mapgeoid-globe-clip">
          <circle cx="16" cy="16" r="13" />
        </clipPath>
      </defs>

      {/* ocean */}
      <circle cx="16" cy="16" r="13" fill="#FFFFFF" />

      <g clipPath="url(#mapgeoid-globe-clip)">
        {/* graticule */}
        <ellipse cx="16" cy="16" rx="6.4" ry="13" stroke="#0F2942" strokeWidth="1" opacity="0.35" fill="none" />
        <path d="M3 16 H29 M4.6 9.6 H27.4 M4.6 22.4 H27.4" stroke="#0F2942" strokeWidth="1" opacity="0.28" />

        {/* landmasses */}
        <path
          d="M12.6 4.2c1.9-.7 4.1-.4 5.6.9 1 .9.6 2.3-.4 3-1.1.8-2.6.6-3.6 1.5-.9.9-.6 2.4.4 3.1 1.2.9 2.9.6 4.1 1.5 1.3 1 1.4 3 .5 4.3-.9 1.4-2.6 2-3.6 3.3-1.1 1.4-1.2 3.4-2.3 4.8-.9 1.1-2.5 1.5-3.7.9-1.4-.7-2-2.4-2.1-3.9-.2-2.4.5-4.8.3-7.2-.2-2.2-1.3-4.4-.7-6.5.6-2.1 2.9-3.3 5.5-4.2z"
          fill="#0F2942"
        />
        <path
          d="M23.4 8.9c1.6-.5 3.4.2 4.4 1.5 1 1.4.9 3.4 0 4.8-.8 1.3-2.4 2-3.9 1.7-1.6-.3-2.9-1.7-3.1-3.3-.2-1.9.8-4.1 2.6-4.7z"
          fill="#0F2942"
        />
        <path
          d="M9.5 25.6c1.4-.3 2.9.5 3.5 1.8.6 1.3.2 3-.9 3.9-1.1.9-2.9.9-4-.1-1.1-1-1.4-2.8-.6-4 .4-.7 1.1-1.4 2-1.6z"
          fill="#0F2942"
        />
      </g>

      {/* rim */}
      <circle cx="16" cy="16" r="13" stroke="#0F2942" strokeWidth="2.6" fill="none" />
    </svg>
  );
}
